import TechSupport from "./TechSupport";

export default TechSupport;
